import type { PolarYesNoUndefined } from "@stryker/core/types/section";
import PolarQuestion from "@/components/job/PolarQuestion";

export type ShutDownPolar = {
  is_component_shutdown_during_repair: PolarYesNoUndefined;
};
type ShutDownChecksProps = {
  onHandleYesNo: (payload: { value: PolarYesNoUndefined; key: keyof ShutDownPolar }) => void;
  polarQuestions: ShutDownPolar;
};
export default function ShutDownChecks({ onHandleYesNo, polarQuestions }: ShutDownChecksProps) {
  return (
    <>
      <PolarQuestion
        shouldRender
        question="Will the component be shut down during repair?"
        onNoClick={() => {
          onHandleYesNo({ value: "no", key: "is_component_shutdown_during_repair" });
        }}
        onYesClick={() => {
          onHandleYesNo({ value: "yes", key: "is_component_shutdown_during_repair" });
        }}
        selection={polarQuestions.is_component_shutdown_during_repair}
      />
    </>
  );
}
